import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RefreshComponent } from './refresh/refresh.component';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PhoneInputComponent } from './shared/phone-input/phone-input.component';
import { CommonImportsModule } from './shared/common-imports/common-imports.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { AppInterceptorService } from './app-interceptor.service';
import { TraceService, createErrorHandler } from '@sentry/angular-ivy';
import { BookAppointmentComponent } from './case-management/book-appointment/book-appointment.component';
import { ListAppointmentComponent } from './case-management/list-appointment/list-appointment.component';
import { CreateAppointmentComponent } from './case-management/create-appointment/create-appointment.component';
import { FollowupDetailsComponent } from './case-management/followup-details/followup-details.component';
import { BillingListComponent } from './case-management/billing-list/billing-list.component';
import { BillingCreateComponent } from './case-management/billing-create/billing-create.component';
import { ViewPdfComponent } from './case-management/view-pdf/view-pdf.component';
import { ClosureReportComponent } from './case-management/closure-report/closure-report.component';
import { ViewBillFilesComponent } from './case-management/view-bill-files/view-bill-files.component';
import { CompanyNavbarComponent } from './company-login/company-navbar/company-navbar.component';
import { CompanyDashboardComponent } from './company-login/company-dashboard/company-dashboard.component';
import { CompanyApptListComponent } from './company-login/company-appt-list/company-appt-list.component';
import { CompanyApptDetailsComponent } from './company-login/company-appt-details/company-appt-details.component';
import { CompanyFollowupDetailsComponent } from './company-login/company-followup-details/company-followup-details.component';
import { ComposeMailComponent } from './mailbox/compose-mail/compose-mail.component';
import { MailListComponent } from './mailbox/mail-list/mail-list.component';
import { MailboxBreadcrumbComponent } from './mailbox/mailbox-breadcrumb/mailbox-breadcrumb.component';
import { MailboxSidebarComponent } from './mailbox/mailbox-sidebar/mailbox-sidebar.component';
import { ViewMailComponent } from './mailbox/view-mail/view-mail.component';
import { FollowupReportComponent } from './case-management/followup-report/followup-report.component';
import { CallListComponent } from './case-management/call-list/call-list.component';
import { PrescriptionOldComponent } from './case-management/prescription-old/prescription-old.component';
import { PrescriptionComponent } from './case-management/prescription/prescription.component';
import { CaseDetailsComponent } from './case-management/case-details/case-details.component';
import { SendReportComponent } from './case-management/send-report/send-report.component';
import { VideoCallComponent } from './case-management/video-call/video-call.component';
import { ChatComponent } from './case-management/chat/chat.component';
import { MessagingService } from './messaging.service';
import { TreatmentCostsComponent } from './case-management/quotation/treatment-costs/treatment-costs.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { UserProfileComponent } from './delete-user-profile/user-profile.component';
import { FollowupFCTComponent } from './case-management/followup-fct/followup-fct.component';
import { RegisteredCandidatesComponent } from './case-management/registered-candidates/registered-candidates.component';
/* import { ViewPdfNewComponent } from './case-management/view-pdf-new/view-pdf-new.component'; */

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		RefreshComponent,
		ResetPasswordNewComponent,
		DashboardComponent,
		NavbarComponent,
		PhoneInputComponent,
		BookAppointmentComponent,
		ListAppointmentComponent,
		CreateAppointmentComponent,
		FollowupDetailsComponent,
		BillingListComponent,
		BillingCreateComponent,
		ViewPdfComponent,
		ClosureReportComponent,
		ViewBillFilesComponent,
		CompanyNavbarComponent,
		CompanyDashboardComponent,
		CompanyApptListComponent,
		CompanyApptDetailsComponent,
		CompanyFollowupDetailsComponent,
		ComposeMailComponent,
		MailListComponent,
		MailboxBreadcrumbComponent,
		MailboxSidebarComponent,
		ViewMailComponent,
		PrescriptionComponent,
		FollowupReportComponent,
		CallListComponent,
		PrescriptionOldComponent,
		CaseDetailsComponent,
		SendReportComponent,
		VideoCallComponent,
		ChatComponent,
		TreatmentCostsComponent,
		TermsConditionsComponent,
		UserProfileComponent,
		FollowupFCTComponent,
		RegisteredCandidatesComponent
	],
	imports: [
		AppRoutingModule,
		CommonImportsModule,
		BrowserAnimationsModule,
		BrowserModule
	],
	providers: [
		{
			provide: ErrorHandler,
			useValue: createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => { },
			deps: [TraceService],
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AppInterceptorService,
			multi: true
		},
		MatNativeDatetimeModule,
		DatePipe,
		MessagingService
	],
	bootstrap: [AppComponent]
})
export class AppModule {

}
